module.exports = __webpack_public_path__ + "static/media/20years.18029264.jpg";